import { render } from "./MotivoRef_Referencia.vue?vue&type=template&id=58f084d8"
import script from "./MotivoRef_Referencia.vue?vue&type=script&lang=js"
export * from "./MotivoRef_Referencia.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__